import { Select } from "antd";
import PropTypes from "prop-types";
const { Option } = Select;

const CustomSelect = ({ items, selectedItem, defaultValue, change, label, disabled = false }) => {
    const options = items.map((item) => (
        <Option key={item._id} value={item._id}>
            {item.name}
        </Option>
    ));

    return (
        <div className="w-full">
            <Select disabled={disabled} value={selectedItem} defaultValue={defaultValue}
                className="w-full  text-[#9A9A9A]  placeholder:text-sm  h-8 " onChange={(e) => change(e)} placeholder={label}>
                {options}
            </Select>
        </div>
    );
};

CustomSelect.propTypes = {
    items: PropTypes.arrayOf(PropTypes.shape({ _id: PropTypes.any })).isRequired,
    change: PropTypes.func.isRequired,
    label: PropTypes.string.isRequired,
};

export default CustomSelect;
